// extracted by mini-css-extract-plugin
module.exports = {"content":"_1AgLLQIrqT8virMGBqrgR3","saveButton":"gcrImKkrRkrjkvLoqLbcG","ageModalContent":"_21ZfVUKIkJ37LW0tILyo9J","title":"_3WTPo7BtTfOgup_5YRCsNu"};